module.exports = __webpack_public_path__ + "static/media/Cross.13eecad3.svg";